export default "__VITE_ASSET__CXMNvXyL__"